import { render, staticRenderFns } from "./my_qrs.vue?vue&type=template&id=0882a370&"
import script from "./my_qrs.vue?vue&type=script&lang=js&"
export * from "./my_qrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports